// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3RZ63","cell":"ColumnAccessor_cell__1PiCx","firstCellAccent":"ColumnAccessor_firstCellAccent__2uUSo"};